import {Chip} from "@mui/material";
import {Floorplan, RoomImage} from "../../../api/apiClient";
import {CONTROLS_INSET_PX} from "./ViewControls";

// This pane is translucent so the panorama shows through, letting the pill sit on the picture instead of blocking it.
const PILL_STYLE = {
    backgroundColor: "rgba(255, 255, 255, 0.45)",
    color: "rgba(6, 41, 47, 1)",
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 16,
    fontWeight: 700
};

export interface LocationPillProps {
    floorPlans: Floorplan[];
    rooms: RoomImage[];
    currentPanorama: string;
}

// Shows where in the house the visitor is standing. Only shows room for their default viewpoints, others show just the floor
export function LocationPill(props: LocationPillProps) {
    const {floorPlans, rooms, currentPanorama} = props;

    const roomName = rooms.find(room => room.targetPanorama === currentPanorama)?.imageHeader;

    // The same lookup the minimap does for its floor tabs: a floor claims the viewpoints on its plan.
    const floorName = floorPlans.find(floorPlan =>
        floorPlan.hotspots.some(hotSpot => hotSpot.targetPanorama === currentPanorama))?.imageHeader;

    const location = [roomName, floorName].filter(Boolean).join(" · ");

    if (!location) {
        return <></>;
    }

    return <Chip label={location}
                 sx={{
                     // Informational, so it never takes the drag that starts on top of it.
                     pointerEvents: "none",
                     position: "absolute",
                     top: CONTROLS_INSET_PX,
                     left: CONTROLS_INSET_PX,
                     ...PILL_STYLE
                 }}/>;
}
